import { connect } from 'react-redux';
import UpdatePaymentProfile from './UpdatePaymentProfile';
import { updatePaymentProfile } from 'actions/payments';
import { compose } from 'redux';
import { formValueSelector } from 'redux-form';

import userPage from '../../decorators/userPage';
import withPurchaseMethods from '../../decorators/withPurchaseMethods';

const mapStateToProps = (state, { location }) => {
  const selector = formValueSelector('updatePaymentProfile');
  const isECheck = location.pathname.includes('update-echeck');
  return {
    card_id: selector(state, 'card_id'),
    isECheck,
  };
};

const mapDispatchToProps = {
  updatePaymentProfile,
};

export default compose(
  userPage,
  withPurchaseMethods,
)(connect(mapStateToProps, mapDispatchToProps)(UpdatePaymentProfile));
